module.exports = __webpack_public_path__ + "img/news2.f9d0a552.png";